import './Navigation.css';
import CancelIcon from '@mui/icons-material/Cancel';
import { useEffect } from 'react';

const Navigation = ({handleopenNav,opennav,scrollhome,scrollabout,scrollprojects,scrollskill,scrollcontact}) => {
    useEffect(()=>{
        window.scroll(0,0);
    },[])
    return (
        <>
            <div className="navigationpage">
                <div className="navigationtop">
                    <h5>© Designed By Alok</h5>
                    <CancelIcon className='cancelicon' onClick={()=>{handleopenNav(!opennav)}}/>
                </div>
                <h3>NAVIGATION</h3>
                <div className="navtop">
                    <p onClick={(e)=>{scrollhome()}}>Home</p>
                    <p onClick={(e)=>{scrollabout()}}>About</p>
                    <p onClick={(e)=>{scrollskill()}}>Skills</p>
                    <p onClick={(e)=>{scrollprojects()}}>Projects</p>
                    <p onClick={(e)=>{scrollcontact()}}>Contact</p>
                </div>
            </div>
        </>
    )
}

export default Navigation;